import styled from "styled-components";

export const Wrapper = styled.div`
  /* border-radius: 5px;
  background-color: #f7f8f9;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17);
element.style { */

    background: #fff;
   padding: 25px;
    border-radius: 10px;
    overflow-x: auto;
    scrollbar-width: thin;
 
    


`

export const AddManageAdminWrapper = styled.div`
margin-top: 15px;
    background-color: white;
   // padding-top: 2px;
   // padding-left: 28px;
    border-radius: 5px;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.17);
  .form-wrapper {
    border-radius: 5px;
   // background-color: #f7f8f9;
   //  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17);

    padding: 40px;
    margin-top: -8px;
    position: relative;
  }
`;
